import type { AiDraftsTranslation } from './types';

export const aiDraftsUr: AiDraftsTranslation = {
  title: 'جائزے کے لیے AI مسودہ',
  by: '{{name}} (AI) نے عوامی ذرائع سے لکھا۔ آپ کی منظوری تک کچھ نہیں بھیجا جاتا۔',
  textLabel: 'جواب کا مسودہ',
  badge: 'مسودہ تیار',
  approve: 'منظور کریں اور بھیجیں',
  edit: 'ترمیم',
  editLabel: 'بھیجنے سے پہلے مسودے میں ترمیم کریں',
  sendEdited: 'ترمیم شدہ بھیجیں',
  cancelEdit: 'ترمیم منسوخ کریں',
  emptyEdit: 'بھیجنے سے پہلے جواب لکھیں، یا ترمیم منسوخ کریں۔',
  reject: 'مسترد کریں',
  sent: 'مسودہ آپ کی طرف سے بھیج دیا گیا۔',
  editedSent: 'آپ کا ترمیم شدہ مسودہ بھیج دیا گیا۔',
  notSent:
    'نہیں بھیجا گیا۔ آپ کا جواب ابھی نہ بھیجے گئے پیغامات کے ساتھ رکھا ہے: جواب کے خانے سے دوبارہ کوشش کریں۔',
  rejected: 'مسودہ مسترد کر دیا گیا۔ کچھ نہیں بھیجا گیا۔',
  closedBy: '{{name}} اس مسودے کا فیصلہ پہلے ہی کر چکے ہیں۔',
  closed: 'یہ مسودہ اب اس گفتگو کے مطابق نہیں رہا۔',
  rejectDialog: {
    title: 'یہ مسودہ مسترد کریں',
    description:
      'گاہک کو کچھ نہیں بھیجا جاتا۔ آپ کی وجہ مسودے کے ساتھ رکھی جاتی ہے تاکہ معاون بہتر ہو سکے۔',
    reason: 'آپ اسے کیوں مسترد کر رہے ہیں؟',
    reasonMissing: 'کوئی وجہ منتخب کریں۔',
    note: 'نوٹ',
    submit: 'مسودہ مسترد کریں',
    reasons: {
      inaccurate: 'یہ غلط ہے',
      incomplete: 'کچھ رہ گیا ہے',
      wrong_tone: 'لہجہ مناسب نہیں',
      not_needed: 'جواب کی ضرورت نہیں',
      other: 'کچھ اور',
    },
  },
  ended: {
    approved: '{{name}} نے یہ مسودہ بھیجا۔',
    edited: '{{name}} نے اس مسودے کا ترمیم شدہ نسخہ بھیجا۔',
    rejected: '{{name}} نے یہ مسودہ مسترد کیا: {{reason}}۔',
    customer_wrote: 'مسودہ بدل دیا گیا: گاہک نے پھر لکھا۔',
    owner_changed: 'مسودہ ایک طرف رکھ دیا گیا: گفتگو کسی اور کے پاس چلی گئی۔',
    answered: 'مسودہ ایک طرف رکھ دیا گیا: کسی نے خود جواب دیا۔',
    replaced: 'ایک نئے مسودے نے اس کی جگہ لے لی۔',
    resolved: 'مسودہ ایک طرف رکھ دیا گیا: گفتگو حل ہو گئی۔',
    dismiss: 'ہٹائیں',
  },
};
